import { cx } from '@linaria/core';
import { useRef } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { useComponentFrameworkState } from '@provider/component-framework';
import { resets } from '@ui/css';
import { IsomorphicPortal, CSSRefTransition } from '@utils/react';
import { panelCls, transitionDurationMs, contentCls, backdropCls } from './panel.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { TransitionSafeFocusOn } from '../containers/focus-on.js';

function Panel(props) {
  const containerRef = useRef(null);
  const targetSelector = useComponentFrameworkState(state => state.overlayContainerSelector);
  const target = targetSelector && document.querySelector(targetSelector) || undefined;
  return /*#__PURE__*/jsx("div", {
    className: resets.rootCls,
    children: /*#__PURE__*/jsx(IsomorphicPortal, {
      target: target,
      children: /*#__PURE__*/jsx(TransitionGroup, {
        component: null,
        children: props.active && /*#__PURE__*/jsx(CSSRefTransition, {
          timeout: transitionDurationMs,
          classNames: panelCls,
          children: ref => /*#__PURE__*/jsxs("dialog", {
            ref: ref,
            open: true,
            "data-position": props.position,
            className: cx(resets.rootCls, panelCls, props.className),
            children: [/*#__PURE__*/jsx(TransitionSafeFocusOn, {
              transitionEnterDuration: transitionDurationMs.enter,
              onEscapeKey: props.onClose,
              onClickOutside: props.onClose,
              scrollLock: true,
              focusLock: true,
              allowPinchZoom: true,
              autoFocus: true,
              preventScrollOnFocus: true,
              children: /*#__PURE__*/jsx("div", {
                ref: containerRef,
                className: contentCls
                // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                ,
                tabIndex: 0,
                children: props.children
              })
            }), !props.noBackdrop &&
            /*#__PURE__*/
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
            jsx("div", {
              className: backdropCls,
              onClick: props.onClose
            })]
          })
        })
      })
    })
  });
}

export { Panel };
//# sourceMappingURL=panel.js.map
